export default __webpack_public_path__ + "static/media/nerdemoji.63626df8.png";